import {
  createApiFactory,
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import {
  ManifestEditorClient,
  manifestEditorApiRef,
} from './api/ManifestEditorApi';
import { rootRouteRef } from './routes';

export const manifestEditorPlugin = createPlugin({
  id: 'manifest-editor',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: manifestEditorApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        identityApi: identityApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, identityApi, fetchApi }) => {
        return new ManifestEditorClient({
          discoveryApi,
          identityApi,
          fetchApi,
        });
      },
    }),
  ],
});

export const ManifestEditorPage = manifestEditorPlugin.provide(
  createRoutableExtension({
    name: 'ManifestEditorPage',
    component: () =>
      import('./components/StandaloneManifestEditorPage').then(
        m => m.StandaloneManifestEditorPage,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const EntityManifestEditorContent = manifestEditorPlugin.provide(
  createComponentExtension({
    name: 'EntityManifestEditorContent',
    component: {
      lazy: () =>
        import('./components/EntityManifestEditorContent').then(
          m => m.EntityManifestEditorContent,
        ),
    },
  }),
);
